















































import Vue from 'vue'
import { DatePicker } from 'element-ui'

export default Vue.extend({
  name: 'DueDateRangePicker',

  extends: DatePicker,

  props: {
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      pickerVisible: true,
      firstPlaceholder: '',
      lastPlaceholder: '',
    }
  },

  watch: {
    displayValue(newValue) {
      this.$emit('selected-range', newValue)
    },
  },

  mounted() {
    // @ts-ignore
    this.showPicker()
  },
})
